import { SidebarContent } from "./sidebar-content";
import { useTranslations } from "next-intl";
import { useLayout } from "./context";

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const t = useTranslations("layout30");
  const { settings } = useLayout();

  return (
    <aside
      data-slot="sidebar-rail"
      aria-label={t(
        settings.audience === "supplier"
          ? "supplierPrimaryNavigation"
          : "primaryNavigation",
      )}
      data-debug-source="components/layouts/layout-30/components/sidebar.tsx"
      className="z-20 flex w-16 shrink-0 flex-col items-center justify-start gap-3 border-e border-border/60 bg-background bg-muted/20 py-3 lg:fixed lg:top-(--header-height) lg:bottom-0 lg:start-0 lg:min-h-0 lg:w-(--sidebar-width)"
    >
      <SidebarContent onNavigate={onNavigate} />
    </aside>
  );
}
